import { JobId } from '@eigtech/restoration-types'
import { ensureJobCorn } from '@eigtech/restoration-util'
import { getResourceId } from '@eigtech/shared-corn'
import { ROUTER_PATHS } from '@/lib/constants'
import { withRequiredPermissions } from '@/lib/permissions'
import { ButtonGroup, ComposedCard, Page } from '@eigtech/ui-shared-dave'
import { MeetingDetailsWithoutChimeEvents, MeetingsTable } from '@eigtech/ui-shared-meetings'
import { LinkButton, LinkMenuItem } from '@eigtech/ui-shared-router'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/jobs/$jobId/_layout/meetings')({
  component: () => <RoutePage />,
})

function JobDetailMeetings() {
  const { jobId } = Route.useParams()

  return (
    <Page
      heading="Meetings"
      toolbarItems={[
        <LinkButton
          key="createOfflineMeeting"
          params={{ jobId }}
          to={ROUTER_PATHS.jobDetailNewMeetingFromVideoUpload.route}
          variant="solid"
        >
          Upload Video as Meeting
        </LinkButton>,
        <LinkButton
          key="startMeeting"
          params={{ jobId }}
          to={ROUTER_PATHS.jobDetailNewMeeting.route}
          variant="solid"
        >
          Start New Meeting
        </LinkButton>,
      ]}
    >
      <ComposedCard>
        <MeetingsTable
          ActionButtons={ActionButtons}
          ActionMenuItems={ActionMenuItems}
          entityId={ensureJobCorn(jobId)}
        />
      </ComposedCard>
    </Page>
  )
}

function ActionMenuItems({ meetingId, entityId, startTime }: MeetingDetailsWithoutChimeEvents) {
  return (
    <LinkMenuItem
      params={{ jobId: getResourceId(entityId) as JobId, meetingStartTime: startTime, meetingId }}
      to={ROUTER_PATHS.jobDetailMeeting.route}
    >
      Open Meeting
    </LinkMenuItem>
  )
}

function ActionButtons({
  meetingId,
  entityId,
  startTime,
  status,
}: MeetingDetailsWithoutChimeEvents) {
  return (
    <ButtonGroup>
      {status === 'active' && (
        <LinkButton
          params={{
            jobId: getResourceId(entityId) as JobId,
            meetingStartTime: startTime,
            meetingId,
          }}
          size="sm"
          to={ROUTER_PATHS.jobDetailMeeting.route}
        >
          Join Meeting
        </LinkButton>
      )}
    </ButtonGroup>
  )
}

const RoutePage = withRequiredPermissions(JobDetailMeetings, {
  requiredPermissions: [{ action: 'read', subject: 'meeting' }],
})
